import React from "react";
import UnclaimButton from "@components/FlowActionButtons/UnclaimButton";
import { useUnclaimResumeCall } from "./hooks";
import { canUserUnclaimResumeCall } from "./utils";

interface UnclaimResumeCallProps {
  refetchVesselCall: () => void;
  refetchInterruption: () => Promise<unknown>;
  vesselCallFlowData?: {
    vesselCallId: string;
    status: string;
  };
  interruptionTaskStatus?: string;
  claimOwnerName?: string;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const UnclaimResumeCall: React.FC<UnclaimResumeCallProps> = ({
  vesselCallFlowData,
  refetchVesselCall,
  refetchInterruption,
  interruptionTaskStatus,
  claimOwnerName,
}) => {
  const { onUnclaimResumeCall } = useUnclaimResumeCall(
    vesselCallFlowData?.vesselCallId,
    refetchVesselCall,
    refetchInterruption,
  );

  if (!vesselCallFlowData) {
    return null;
  }

  const interruptionStatus = interruptionTaskStatus;
  const ownerName = claimOwnerName;

  const isActionAvailable =
    interruptionStatus != null && ownerName != null
      ? canUserUnclaimResumeCall(interruptionStatus, ownerName)
      : false;

  return (
    <UnclaimButton
      langBase={LANG_BASE}
      permission="canUnclaimResumption"
      isActionAvailable={isActionAvailable}
      onUnclaim={onUnclaimResumeCall}
    />
  );
};

export default UnclaimResumeCall;
